<template>
  <div>
    <div
      v-if="loading"
      class="flex justify-center items-center h-screen w-screen fixed top-0 left-0 bg-white z-50"
    >
      <div class="animate-pulse text-xl">Carregando...</div>
    </div>
    <div v-else>
      <div class="px-5 py-9">
        <div></div>
        <div class="text-center">
          <img src="@/assets/logo.png" class="mx-auto" />
        </div>
      </div>
      <div class="py-3">
        <div class="mx-5 text-current text-left fontSize28 font-normal">
          Gerenciar fotos
        </div>
        <div
          class="mt-3 tracking-wide text-sm text-left mx-5 font-normal text-gray-400"
        >
          Verifique se as fotos estão corretas e clique em finalizar para enviar
          para o totem
        </div>
      </div>
      <div class="flex w-full overflow-x-auto py-2">
        <div
          class="m-2 containFoto inline-block flex-none relative transition"
          v-if="listaFotos.length < 1"
          @click="clickBtnToSelect"
        >
          <div
            class="inline-flex itemFoto rounded-md bg-gray-100 justify-center items-center animate-pulse"
          >
            <svg-icon
              type="mdi"
              :path="getIconPlus"
              class="text-pink-600 fill-current h-16 w-16"
            ></svg-icon>
            <div id="plus"></div>
          </div>
        </div>
        <div
          class="m-2 containFoto inline-block flex-none relative transition"
          :key="index"
          v-for="(item, index) in listaFotos"
        >
          <button
            @click="removeItem(index)"
            class="absolute right-0 bg-primary fill-current text-white p-3 -mt-2 -mr-2 rounded-md"
          >
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.41667 3.5V2.58333C4.41667 1.57081 5.23748 0.75 6.25 0.75H11.75C12.7625 0.75 13.5833 1.57081 13.5833 2.58333V3.5H16.3333C16.8396 3.5 17.25 3.91041 17.25 4.41667C17.25 4.92293 16.8396 5.33333 16.3333 5.33333H15.4167V15.4167C15.4167 16.9355 14.1854 18.1667 12.6667 18.1667H5.33333C3.81455 18.1667 2.58333 16.9355 2.58333 15.4167V5.33333H1.66667C1.16041 5.33333 0.75 4.92293 0.75 4.41667C0.75 3.91041 1.16041 3.5 1.66667 3.5H4.41667ZM6.25 2.58333H11.75V3.5H6.25V2.58333ZM4.41667 5.33333H13.5833V15.4167C13.5833 15.9229 13.1729 16.3333 12.6667 16.3333H5.33333C4.82707 16.3333 4.41667 15.9229 4.41667 15.4167V5.33333Z"
                fill="white"
              />
            </svg>
          </button>
          <img class="inline-block itemFoto rounded-md" :src="item.src" />
        </div>
      </div>
      <div class="mx-5 font-body mb-11 font-normal text-gray-800 text-left">
        Fotos: {{ listaFotos.length }} de {{ getCompra.qtde_foto }}
      </div>
      <div>
        <input
          @change="eventChange"
          type="file"
          id="fileup"
          class="hidden"
          accept=".png,.jpeg,.jpg,.bmp,.heif"
          multiple
        />

        <button
          @click="clickBtnToSelect()"
          class="btn btn-outline text-center"
          :class="{
            'bg-gray-200 text-gray-400': loadingBtn,
          }"
          :disabled="disableButton"
        >
          <span v-if="disableButtonRoleFotos">Selecionar fotos</span>
          <span v-else>Selecionar outras fotos</span>
        </button>
      </div>
      <div>
        <button
          @click="uploadNow()"
          :disabled="disableButton || disableBtnEnviarFotos"
          class="btn font-normal text-center"
          :class="{
            'border-gray-300 border border-solid bg-gray-200  text-gray-400 shadow-none':
              loadingBtn || disableBtnEnviarFotos,
          }"
        >
          <div v-if="loadingBtn">
            <div class="flex justify-center items-center text-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-8 h-8 mx-auto animate-spin"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
            </div>
            <span class="text-current text-2xl font-normal"
              >Enviado <strong>{{ contagem }}</strong> de
              <strong>{{ listaFotos.length }}</strong></span
            >
          </div>
          <div v-else>Enviar fotos selecionadas</div>
        </button>
      </div>
      <v-modal v-if="modalToggle">
        <div
          class="text-sm absolute right-2 top-2 inline-block"
          @click="modalToggle = false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="py-1 font-normal text-left">
          {{ modalMsg }}
        </div>
      </v-modal>
      <v-modal v-if="executandoLimpeza || modalLimpezaToggle">
        <div class="font-normal text-left text-slate-700">
          <div class="font-bold text-lg mb-2">Ops...</div>
          <div class="font-normal text-base mb-6">
            Ocorreu um problema no processo de upload, você poderá tentar
            novamente
          </div>
          <div class="text-center mt-3">
            <button
              v-if="!executandoLimpeza"
              class="py-4 px-5 w-full mx-auto text-center bg-primary fill-current text-white block rounded-lg shadow-lg"
              @click="closeModalLimpeza()"
            >
              Ok, tentar novamente
            </button>
            <div class="text-primary text-center pb-2" v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-10 h-10 mx-auto animate-spin"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
            </div>
          </div>
        </div>
      </v-modal>
    </div>
  </div>
</template>

<script>
import { db, storageRef } from "@/service/firebase";
import { marcarCodeUsado } from "@/service/auth";
import { mdiImagePlus } from "@mdi/js";
import { doc, setDoc } from "firebase/firestore";
import moment from "moment";
import etapaCompra from "../../constants/etapaCompra";
import { CarregaDadosDaCompra, loggerError } from "../../service/firebase";
import { reduzirFoto } from "../../utils/reduzirFoto";

export default {
  data() {
    return {
      loading: false,
      modalMsg: "",
      modalToggle: false,
      listaFotos: [],
      files: [],
      contagem: 0,
      loadingBtn: false,
      errorUpload: false,
      executandoLimpeza: false,
      modalLimpezaToggle: false,
    };
  },
  mounted() {
    this.carregarCompra();
  },
  computed: {
    disableBtnEnviarFotos() {
      return this.listaFotos.length != this.getCompra.qtde_foto;
    },
    disableButton() {
      return this.executandoLimpeza || this.loadingBtn;
    },
    disableButtonRoleFotos() {
      return this.listaFotos.length < this.getCompra.qtde_foto;
    },
    getIconPlus() {
      return mdiImagePlus;
    },
    getCompra() {
      return this.$store.getters["compra/getCompra"];
    },
  },
  methods: {
    carregarCompra() {
      this.loading = true;
      let compraID = localStorage.getItem("compra_id");
      if (compraID && compraID.length > 3) {
        CarregaDadosDaCompra(compraID)
          .then((compra) => {
            this.$store.commit("compra/setCompra", compra);
            if (compra.etapa !== etapaCompra.UPLOAD) {
              loggerError(
                `Compra não está na etapa de UPLOAD, está em: ${compra.etapa}`
              );
              this.$router.push("/nao-autorizado");
              return;
            }
            this.loading = false;
          })
          .catch((error) => {
            loggerError(error);
            this.$router.push("/nao-autorizado");
          });
      } else {
        loggerError(
          "carregarCompra():compra_id nao foi registrado no localStorage"
        );
        this.$router.push("/nao-autorizado");
      }
    },
    closeModalLimpeza() {
      this.modalLimpezaToggle = false;
    },
    async eventChange() {
      var self = this;
      let files = document.querySelector("#fileup").files;
      async function readAndPreview(file) {
        // gif type removed for possible bugs
        if (/\.(jpe?g|png|bmp|heif)$/i.test(file.name)) {
          try {
            // Reduz a foto aqui: o totem não aguenta fotos de 12 MP.
            const src = await reduzirFoto(file);
            self.listaFotos.push({ src });
          } catch (error) {
            loggerError(error);
            self.modalMsg =
              "Não foi possível ler esta foto. Tente selecionar novamente.";
            self.modalToggle = true;
          }
        } else {
          self.modalMsg =
            "Formato de arquivo inválido, apenas PNG, JPEG, JPG, BMP, HEIF são aceitos.";
          self.modalToggle = true;
          return false;
        }
      }

      if (files) {
        // Uma foto por vez: decodificar várias de 12 MP juntas estoura a
        // memória de celulares mais simples.
        for (const file of Array.from(files)) {
          await readAndPreview(file);
        }
      }
    },
    liberarAcessos() {
      this.errorUpload = false;
      this.loadingBtn = false;
      this.contagem = 0;
      this.modalLimpezaToggle = true;
      this.executandoLimpeza = false;
    },
    async limparFotosPorCompraId() {
      await db
        .collection("fotos")
        .where("compra_id", "==", localStorage.getItem("compra_id"))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            db.collection("fotos").doc(doc.id).delete();
          });
        });
    },
    async limpaStoragePorReferencia() {
      console.log("LIMPANDO STORAGE");
      let compraId = this.$store.getters["compra/getCompra"].id;
      for (var i = 0; i < this.listaFotos.length; i++) {
        let mountPath = `public/${compraId}/original/${i}`;
        await storageRef
          .child(mountPath)
          .delete()
          .then(() => {
            console.log("Deletou: " + mountPath);
          })
          .catch(() => {
            // o erro acontece quando não existe a referencia é normal.
            console.error("Erro ao limpar storage / foto não existe");
          });
      }
    },
    async limparResidosPorCompraId() {
      this.executandoLimpeza = true;
      await this.limpaStoragePorReferencia();
      await this.limparFotosPorCompraId();
      this.liberarAcessos();
    },
    tratamentoEmCasoDeErroUpload() {
      this.errorUpload = true;
      this.loadingBtn = false;
      this.count = 0;
      this.limparResidosPorCompraId();
    },
    async processosMobileConcluidos() {
      let compraId = this.$store.getters["compra/getCompra"].id;
      const docRef = doc(db, "compras", `${compraId}`);
      await setDoc(docRef, { etapa: etapaCompra.EDICAO }, { merge: true });
      // fire-and-forget: não bloqueia navegação nem exibe erro ao usuário
      marcarCodeUsado().catch(() => {});
      this.$router.push(`/user/upload-sucesso`);
    },
    validaQuantidadeNoSistema(contagem) {
      const qtdFotoLocal = this.listaFotos.length;
      if (qtdFotoLocal != contagem) {
        this.tratamentoEmCasoDeErroUpload();
      } else {
        this.processosMobileConcluidos();
      }
    },
    async verificarUploads() {
      try {
        let compraId = this.$store.getters["compra/getCompra"].id;
        const querySnapshot = await db
          .collection("fotos")
          .where("compra_id", "==", compraId)
          .get();

        const count = querySnapshot.size;
        this.validaQuantidadeNoSistema(count);
      } catch (error) {
        console.log("Error verificar UPLOADS ", error);
        this.tratamentoEmCasoDeErroUpload();
      }
    },
    async createReferenceFirestore(path) {
      const compra_id = localStorage.getItem("compra_id");
      await db
        .collection("fotos")
        .add({
          url_original: path,
          url_editada: path.replace("original", "editada"),
          compra_id: compra_id,
          data: moment().format("DD/MM/YYYY"),
          horario: moment().format("hh:mm:ss"),
        })
        .then(() => {
          this.contagem += 1;
        })
        .catch((error) => {
          this.tratamentoEmCasoDeErroUpload();
          console.log("Error ao criar referência no firestore ", error);
        });
    },
    async createTaskUpload(imgBase64, index) {
      let compra_id = localStorage.getItem("compra_id");
      const pathStorage = `public/${compra_id}/original/${index}`;

      await storageRef
        .child(pathStorage)
        .putString(imgBase64, "data_url")
        .then(async () => {
          await this.createReferenceFirestore(pathStorage);
        })
        .catch((error) => {
          console.log(error);
          this.tratamentoEmCasoDeErroUpload();
        });
    },
    validationsUpload() {
      if (this.getCompra.qtde_foto !== this.listaFotos.length) {
        if (this.getCompra.qtde_foto > this.listaFotos.length) {
          this.modalMsg =
            "Você deve adicionar mais fotos até completar " +
            this.getCompra.qtde_foto +
            " fotos.";
          this.modalToggle = true;
          return false;
        }
        if (this.getCompra.qtde_foto < this.listaFotos.length) {
          this.modalMsg =
            "Você passou do seu limite de fotos, remova até chegar a " +
            this.getCompra.qtde_foto +
            " fotos.";
          this.modalToggle = true;
        }
        return false;
      }

      return true;
    },
    async uploadNow() {
      if (!this.validationsUpload()) return;
      this.loadingBtn = true;
      this.errorUpload = false;
      for (let i = 0; i < this.listaFotos.length; i++) {
        if (!this.errorUpload) {
          await this.createTaskUpload(this.listaFotos[i].src, i);
        }
      }
      if (!this.errorUpload) {
        this.verificarUploads();
      }
    },
    clickBtnToSelect() {
      if (this.disableButton) return;
      document.querySelector("#fileup").click();
    },
    removeItem(index) {
      this.listaFotos.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.containFoto {
  width: 200px;
}
.itemFoto {
  width: 200px;
  height: 200px;
  object-fit: cover;
}
.fontSize28 {
  font-size: 28px;
}
</style>
